import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { getProductBySlug, getRelatedProducts } from "../productsData";
import ProductGallery from "../components/shop/ProductGallery";
import ProductPurchasePanel from "../components/shop/ProductPurchasePanel";
import ProductInfoStrip from "../components/shop/ProductInfoStrip";
import ProductGrid from "../components/shop/ProductGrid";

export default function ProductDetail() {
  const { slug } = useParams();
  const product = getProductBySlug(slug);

  if (!product) {
    return <Navigate to="/shop" replace />;
  }

  const related = getRelatedProducts(product);

  return (
    <>
      <section className="track-hero">
        <div className="container">
          <nav className="track-breadcrumb">
            <Link to="/shop">Shop</Link>
            <span>/</span>
            <Link to="/shop">{product.category}</Link>
            <span>/</span>
            <span className="current">{product.name}</span>
          </nav>

          <div className="row g-5">
            <div className="col-lg-6">
              <ProductGallery images={product.images} name={product.name} />
            </div>
            <div className="col-lg-6">
              <ProductPurchasePanel product={product} />
            </div>
          </div>
        </div>
      </section>

      <ProductInfoStrip product={product} />
      <ProductGrid title="You Might Also Like" products={related} />
    </>
  );
}
